import React from "react";
import "./index.css";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { Navbar } from "../../../components/Navbar";
import { useMoodle } from "../../../contexts/MoodleContext";
import { useTheme } from "../../../contexts/ThemeContext";
import { PROGRESS_DETAIL } from "../../../utils/state";
import { ProgressRowItemDetail } from "../ProgressRowItemDetail";
import { ProgressTable } from "../ProgressTable";
import { Table } from "@nejcm/react-skeleton";
import { ProgressTitle } from "../ProgressTitle";
import { useAuth } from "../../../contexts/AuthContext";
import { useConfig } from "../../../contexts/config";

export const ProgressDetail = () => {
  const theme = useTheme();
  const moodle = useMoodle();
  const location = useLocation();
  const params = useParams();
  const { lang } = useAuth();
  const { config }= useConfig()
  const navigation = useNavigate();
  const [data, setData] = React.useState(null);
  const [titles, setTitles] = React.useState(PROGRESS_DETAIL);

  React.useEffect(() => {
    if (!location.state?.name) {
      navigation("/listcourses/progress/");
      return;
    }
    // setTimeout(() => {
    fetchDetails();
    // }, 1500);

    if (lang) {
      setTitles({
        title: lang["History"].inner_title,
        headers: [
          lang["History"].inner_first_column,
          lang["History"].inner_second_column,
          lang["History"].inner_third_column,
          "Feedback",
          ...(config.opciones.includes("feedback") ? [
            lang["History"].inner_fourth_column,
            lang["History"].inner_fifth_column,
          ] : []),
        ],
      });
    }
    console.log("renderizando");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchDetails() {
    try {
      const [grades /* progress */] = await moodle.getProgressDetail(params.id);
      //console.log({ grades });
      const filterdata = grades.usergrades[0].gradeitems
        .filter((d) => d.itemname !== null)
        .filter((d) => d.itemname !== "")
        .filter((d) => !d.gradeishidden);
      /*       console.log({ progress }); */

      setData(filterdata);
    } catch (e) {
      console.log(e.message);
    }
  }

  return (
    <>
      <Navbar />
      <div
        className="flex flex-col w-full px-4 py-48 min-h-dvh"
        style={{
          backgroundColor: theme.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgb(34, 34, 34)", // TODO: Cambiar Styles por Colors
          gap: "36px",
        }}
      >
        <div className="container w-full space-y-3">
          {/* <div className="breadcrumb-container">
          <ul className="breadcrumb-ul">
            <Link to={"/listcourses"}>
              <li className="breadcrumb-li">Inicio</li>
            </Link>
            <span>/</span>
            <Link to={"/listcourses/progress/"}>
              <li className="breadcrumb-li">Historial</li>
            </Link>
            <span>/</span>
            <Link to={`/detailcourse/${params.id}`}>
              <li className="breadcrumb-li">{location.state?.name || null}</li>
            </Link>
          </ul>
        </div> */}
          {/* <ProgressTitle title={titles.title} /> */}

          <div className="flex flex-col gap-4">
            <p
              className="font-medium text-4xl"
              style={{ color: theme.colors.textColorDefault }}
            >
              {location.state?.name || ""}
            </p>
            {!data ? (
              <Table
                widths={["40%", "15%", "15%", "15%", "15%"]}
                rows={10}
                cols={["", "", "", "", ""]}
              />
            ) : (
              <ProgressTable headers={titles.headers}>
                {/* <tr>
              <th scope="row" className="title-row-detail">
                {location.state?.name || null}
              </th>
            </tr> */}
                {data &&
                  data.map((d, idx) => {
                    return (
                      <ProgressRowItemDetail key={idx} detail={d} index={idx} includeFeedback={config.opciones.includes("feedback")}/>
                    );
                  })}
              </ProgressTable>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    margin: "0 auto",
    width: "80%",
    paddingTop: "10rem",
    minHeight: "100vh",
  },
};
